import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ModalPortal from "../common/ModalPortal";

/**
 * "Reject this entry?" confirmation for the transcript-review flow.
 * Rejecting an entry marks its captured item as discarded_in_review
 * on the server so it's excluded from Save & next; the row stays in
 * the review table with a strikethrough treatment so the reviewer has
 * an audit trail of what was declined.
 */
const RejectConfirmDialog = ({
  name,
  submitting,
  onCancel,
  onConfirm,
}) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && !submitting && onCancel();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel, submitting]);

  return (
    <ModalPortal>
      <div
        className="cc-modal-backdrop rejc-backdrop"
        onMouseDown={submitting ? null : onCancel}
      >
        <div
          className="rejc"
          onMouseDown={(e) => e.stopPropagation()}
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="rej-confirm-title"
        >
          <div className="rejc-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <path d="M4.93 4.93l14.14 14.14" />
            </svg>
          </div>
          <h2 id="rej-confirm-title" className="rejc-title">
            Reject this entry?
          </h2>
          <p className="rejc-body">
            <strong>&ldquo;{name}&rdquo;</strong> will not be saved to the patient&apos;s record.
          </p>
          <footer className="rejc-actions">
            <button
              type="button"
              className="rejc-cancel"
              onClick={onCancel}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="button"
              className="rejc-reject"
              onClick={onConfirm}
              disabled={submitting}
            >
              {submitting ? "Rejecting…" : "Reject entry"}
            </button>
          </footer>
        </div>
      </div>
    </ModalPortal>
  );
};

RejectConfirmDialog.propTypes = {
  name: PropTypes.string.isRequired,
  submitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

RejectConfirmDialog.defaultProps = { submitting: false };

export default RejectConfirmDialog;
